import React, { FC } from 'react';
import { Connect, PropsFromRedux } from './ZeroResultsRouterContainer';
import { ZeroDecisionResults } from './ZeroDecisionResults';
import { ZeroCommonResults } from './ZeroCommonResults';

type Props = PropsFromRedux;

const RawZeroResultsRouter: FC<Props> = ({
  hasNoResults,
  isSearchLoading,
  searchType,
  hasDecisionRef,
  hasError,
}) => {
  if (hasError || !hasNoResults || isSearchLoading) {
    return null;
  }
  if (searchType === 'arret') {
    return (
      <ZeroDecisionResults
        searchType={searchType}
        hasDecisionRef={hasDecisionRef}
      />
    );
  }
  return <ZeroCommonResults searchType={searchType} />;
};

export const ZeroResultsRouter = Connect(RawZeroResultsRouter);
